module.exports = __webpack_public_path__ + "static/media/sidebar-4.a2ad6504.jpg";